"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.common = exports.onInstanceChangeListener = void 0;
var angular = require("angular");
var focusOn_1 = require("./directives/focusOn");
var visualFocusOn_1 = require("./directives/visualFocusOn/visualFocusOn");
require("ng-debounce/dist/ng-debounce.js");
var sdkEvents_1 = require("./services/sdkEvents");
var sdkSettings_1 = require("./services/sdkSettings");
var appClientService_1 = require("./services/appClientService");
var settingsManager_1 = require("./services/settingsManager");
var cartStorage_1 = require("./services/cartStorage");
function onInstanceChangeListener(cb) {
    window.Wix.addEventListener(window.Wix.Events.INSTANCE_CHANGED, function (response) {
        return cb(response.instance);
    });
}
exports.onInstanceChangeListener = onInstanceChangeListener;
exports.common = angular
    .module('common', ['eComSFSMCommon', 'debounce'])
    .config(["HttpFacadeProvider", function (HttpFacadeProvider) {
    HttpFacadeProvider.setOnInstanceUpdate(onInstanceChangeListener);
}])
    .service('cartStorage', cartStorage_1.CartStorage)
    .constant('MULTILINGUAL_LANGUAGE', window.__MULTILINGUAL_LANGUAGE__)
    .directive('focusOn', focusOn_1.focusOn)
    .directive('visualFocusOn', visualFocusOn_1.visualFocusOn)
    .factory('focus', focusOn_1.focus)
    .service('sdkSettings', sdkSettings_1.SdkSettings)
    .service('sdkEvents', sdkEvents_1.SdkEvents)
    .service('appClientService', appClientService_1.appClientService)
    .service('settingsManager', settingsManager_1.SettingsManager).name;
